import { render, staticRenderFns } from "./WealthHeading.vue?vue&type=template&id=5670f88b&scoped=true&"
import script from "./WealthHeading.vue?vue&type=script&lang=ts&"
export * from "./WealthHeading.vue?vue&type=script&lang=ts&"
import style0 from "./WealthHeading.vue?vue&type=style&index=0&id=5670f88b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670f88b",
  null
  
)

export default component.exports